import { render, staticRenderFns } from "./modalShow.vue?vue&type=template&id=1216f804&scoped=true&"
import script from "./modalShow.vue?vue&type=script&lang=js&"
export * from "./modalShow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=1216f804&scoped=true&lang=css&"
import style1 from "./modalShow.vue?vue&type=style&index=1&id=1216f804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216f804",
  null
  
)

export default component.exports